"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var RichTextEditor_1 = __importDefault(require("../../Components/RichTextEditor"));
var antd_1 = require("antd");
var ArticleEditorUtil_1 = require("../../Components/ArticleEditor/ArticleEditorUtil");
function RevRichTextField(props) {
  var _this = this;
  var schema = props.schema,
    uiSchema = props.uiSchema,
    formData = props.formData,
    onChange = props.onChange;
  var _a = react_1.useState(false),
    openModal = _a[0],
    setOpenModal = _a[1];
  var _b = react_1.useState(formData.content),
    content = _b[0],
    setContent = _b[1];
  if (uiSchema.hidden) {
    return null;
  }
  return react_1.default.createElement("div", {
    style: {
      margin: '10px 0',
      maxWidth: 800
    }
  }, react_1.default.createElement("div", {
    style: {
      marginBottom: 10
    }
  }, schema.title || schema.title), react_1.default.createElement("div", {
    style: {
      border: '1px #999',
      borderStyle: !!formData.html ? 'solid' : 'dashed',
      backgroundColor: !!formData.html ? '#fff' : '#ddd',
      width: '100%',
      height: 300,
      cursor: 'pointer'
    },
    onClick: function onClick(e) {
      e.preventDefault();
      setOpenModal(true);
    }
  }, formData.html ? react_1.default.createElement("div", {
    style: {
      padding: 5,
      maxWidth: '100%',
      height: '100%',
      overflowY: 'scroll',
      overflowX: 'hidden'
    }
  }, react_1.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: formData.html
    },
    style: {
      width: '100%'
    }
  })) : react_1.default.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#999'
    }
  }, "\u65B0\u589E(\u76EE\u524D\u7121\u5167\u5BB9)")), react_1.default.createElement(antd_1.Modal, {
    visible: openModal,
    width: "80%",
    onCancel: function onCancel() {
      return setOpenModal(false);
    },
    onOk: function onOk() {
      return __awaiter(_this, void 0, void 0, function () {
        var _a;
        var _b;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              _a = onChange;
              _b = {
                content: content
              };
              return [4 /*yield*/, ArticleEditorUtil_1.generateHtml(content)];
            case 1:
              return [4 /*yield*/, _a.apply(void 0, [(_b.html = _c.sent(), _b)])];
            case 2:
              _c.sent();
              setOpenModal(false);
              return [2 /*return*/];
          }
        });
      });
    }
  }, react_1.default.createElement(RichTextEditor_1.default, {
    options: {},
    token: "",
    onChange: function onChange(value) {
      return setContent(value);
    },
    content: content
  })));
}
exports.default = RevRichTextField;